import { FC } from 'react';

type Props = {
	className?: string;
};

const ApproximatelyEqualIcon: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			stroke='#2B2B2B'
			className={className}>
			<path
				d='M4 6.94529C6.00006 4.69605 8.00011 5.35433 10.0002 7.00004C12.0002 8.64573 14.0002 9.30403 16.0003 7.05479'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M4 12.9453C6.00006 10.696 8.00011 11.3543 10.0002 13C12.0002 14.6457 14.0002 15.304 16.0003 13.0548'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default ApproximatelyEqualIcon;
